module.exports = __webpack_public_path__ + "bda77ac8b077fda42e39b684cd3e7ef9.ttf";